// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/commercial-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/booking-card-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/commercial-mobile-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-service-wrapper {
  border: 1px solid #f3f3f3;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 18px 40px 38px 40px;
}

.dashboard-main-wrap {
  margin-top: 45px;
}

.dashboard-service-wrapper h3 {
  font-size: 24px;
  color: #1a1919;
  font-weight: 700;
}

.dashboard-commercial-wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}

.dashboard-commercial-image-wrap {
  /* width: 231px; */
  width: 190px;
  transition: background-color 0.3s ease, transform 0.3s ease;
  border-radius: 50%;
  padding: 10px;
  /* background: #fff; */
  object-fit: cover;
}

.dashboard-commercial-image-wrap img {
  width: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.dashboard-commercial-wrap:hover .dashboard-commercial-image-wrap {
  /* background-color: #f6f6f6; */
  cursor: pointer;
}

.dashboard-commercial-wrap:hover .dashboard-commercial-image-wrap img {
  transform: scale(1.1);
}

.dashboard-commercial-wrap:hover .round-button img {
  transform: scale(1.06);
}

.dashboard-service-wrap {
  width: 100%;
  display: flex;
  gap: 160px;
  justify-content: center;
  /* margin-top: 10px; */
  margin-top: 40px;
  margin-bottom: 10px;
}

.dashbord-right-image-wrapper {
  text-align: right;
}

.dashbord-right-image-wrapper img {
  width: 86%;
}

.dashboard-history-main-wrapper {
  margin-top: 20px;
}

.dashboard-history-main-wrap {
  display: grid;
  grid-template-columns: auto auto;
  gap: 20px;
}

.dashboard-history-repeat {
  border: 1px solid #f3f3f3;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  transition: transform 0.3s ease;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  height: 163px;
  gap: 30px;
  cursor: pointer;
}

.dashboard-history-repeat:hover {
  border: 1px solid #00a19b;
}

.dashbord-history-icon-wrap img {
  width: 99px;
}

.dashboard-history-contant p {
  font-size: 18px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.dashboard-history-repeat.upcoming-active .dashboard-history-contant p {
  color: #1fae04;
}

.dashboard-history-contant h4 {
  font-size: 34px;
  color: #14172e;
  font-weight: bold;
  padding-top: 5px;
  margin: 0px;
}

.dashboard-history-repeat.upcoming-active .dashboard-history-contant h4 {
  color: #1fae04;
}

/******* Resposive css ****/
@media (max-width: 1024px) {
  .dashboard-service-wrapper {
    padding: 8px;
    height: 226px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  .dashboard-history-main-wrapper {
    margin-top: 16px;
  }

  .dashboard-history-repeat:hover {
    border: 1px solid #00a19b;
  }

  .dashboard-service-wrapper h3 {
    font-size: 14px;
    font-weight: bold;
    display: none;
  }

  .dashboard-commercial-image-wrap {
    /* width: 86px; */
    width: 76px; /*** new added ***/
    padding: 0px;
  }

  .round-button {
    height: 46px;
  }

  .dashboard-commercial-wrap {
    flex-direction: row;
    gap: 26px;
  }

  .dashboard-service-wrap {
    flex-direction: column;
    gap: 12px;
    margin-top: 25px; /*** new added ***/
  }

  .dashboard-history-main-wrap {
    display: grid;
    grid-template-columns: auto auto;
    gap: 12px;
  }

  .dashbord-right-image-wrapper {
    display: none;
  }

  .dashboard-history-repeat {
    background-image: unset;
    gap: 6px;
    /* width: 141px; */
    height: 141px;
    flex-direction: column;
    text-align: center;
    padding: 12px;
  }

  .dashbord-history-icon-wrap img {
    /* width: 45px; */
    width: 50px;
  }

  .dashboard-history-contant p {
    font-size: 16px;
    line-height: normal;
  }

  .dashboard-history-contant h4 {
    font-size: 18px;
  }

  .dashboard-main-wrap {
    padding-bottom: 100px;
    margin-top: 20px;
  }
}

@media (max-width: 360px) {
  .dashboard-service-wrapper {
    padding: 20px;
  }

  .dashboard-history-repeat {
    gap: 6px;
  }
}

@media (max-width: 330px) {
  .dashboard-service-wrapper {
    padding: 20px;
  }

  .dashboard-history-contant p {
    font-size: 12px;
  }

  .dashboard-history-repeat {
    gap: 6px;
    padding: 10px;
  }

  .dashboard-history-contant h4 {
    font-size: 16px;
  }

  .dashboard-commercial-image-wrap {
    width: 84px;
  }

  .dashboard-commercial-wrap {
    gap: 14px;
  }

  .round-button {
    font-size: 12px;
  }

  .round-button img {
    width: 14px;
  }

  .dashbord-history-icon-wrap img {
    width: 56px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .dashboard-service-wrapper {
    padding: 6px;
    height: 270px;
  }

  .dashboard-service-wrap {
    margin-top: 20px;
    margin-bottom: 0px;
  }

  .dashboard-service-wrapper h3 {
    font-size: 22px;
  }

  .dashboard-commercial-image-wrap {
    width: 100px;
  }

  .dashbord-history-icon-wrap img {
    width: 60px;
  }

  .dashboard-history-contant h4 {
    font-size: 22px;
  }

  .dashboard-history-contant p {
    font-size: 16px;
  }

  .dashboard-history-repeat {
    height: 150px;
    padding: 12px;
    gap: 10px;
  }

  .dashbord-right-image-wrapper img {
    width: 100%;
  }

  .col-md-12.col-lg-7.dashbord-full-width {
    width: 100%;
  }

  .dashbord-right-image-wrapper {
    display: none;
  }
}

@media (min-width: 1025px) and (max-width: 1199px) {
  .dashboard-service-wrapper {
    padding: 20px 26px;
    height: 280px;
  }


  .dashboard-main-wrap {
    margin-top: 10px;
    display: flex; 
    justify-content: center;
    align-items: center;
    height: calc(100vh - 90px);
  }

  .dashboard-service-wrap {
    margin-top: 20px;
    margin-bottom: 0px;
  }

  .dashboard-service-wrapper h3 {
    font-size: 16px;
  }

  .dashboard-commercial-image-wrap {
    width: 140px;
  }

  .dashbord-history-icon-wrap img {
    width: 56px;
  }

  .dashboard-history-contant h4 {
    font-size: 20px;
  }

  .dashboard-history-contant p {
    font-size: 14px;
  }

  .dashboard-history-repeat {
    height: 90px;
    padding: 12px;
    gap: 10px;
  }

  .dashbord-full-width {
    padding-bottom: 20px;
  }

  .dashbord-right-image-wrapper img {
    width: 100%;
    /* height: calc(100vh - 130px);
        object-fit: fill; */
  }

  .dashboard-commercial-wrap {
    gap: 14px;
  }

  .round-button {
    height: 40px;
    font-size: 12px;
    width: 130px;
  }
}

@media (min-width: 1200px) and (max-width: 1599px) {
  .dashboard-main-wrap {
    margin-top: 10px;
    display: flex; 
    justify-content: center;
    align-items: center;
    height: calc(100vh - 90px);
  }

  .dashboard-service-wrapper {
    padding: 23px 27px;
    height: 287px;
  }

  .dashboard-service-wrapper h3 {
    font-size: 16px;
  }

  .dashboard-commercial-image-wrap {
    /* width: 150px; */
    width: 120px; /*** new added ***/
  }

  .round-button {
    height: 40px;
    font-size: 12px;
    width: 130px;
  }

  .dashboard-commercial-wrap {
    gap: 14px;
  }

  .dashboard-service-wrap {
    /* margin-top: 10px; */
    margin-top: 24px; /*** new added ***/
    margin-bottom: 0px;
  }

  .dashbord-history-icon-wrap img {
    width: 66px;
  }

  .dashboard-history-contant h4 {
    font-size: 24px;
  }

  .dashboard-history-repeat {
    height: 107px;
  }

  .dashboard-history-contant p {
    font-size: 16px;
  }

  .dashbord-right-image-wrapper {
    text-align: right;
    width: 394px;
    height: 538px;
  }

  .dashbord-right-image-wrapper img {
    width: 100%;
  }

  .dashboard-right-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

@media (min-width: 1600px) {
  .dashboard-service-wrapper {
    height: 396px;
  }

  .dashbord-right-image-wrapper img {
    width: 86%;
    height: 760px;
  }

  .dashboard-history-repeat {
    padding: 32px 39px;
    gap: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yDAAuD;EACvD,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2DAA2D;EAC3D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yDAAyD;EACzD,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,aAAa;IACb,yDAA8D;EAChE;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW,EAAE,kBAAkB;IAC/B,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB,EAAE,kBAAkB;EACtC;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;EACf;;;EAGA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX;2BACuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY,EAAE,kBAAkB;EAClC;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,gBAAgB,EAAE,kBAAkB;IACpC,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;AACF","sourcesContent":[".dashboard-service-wrapper {\r\n  border: 1px solid #f3f3f3;\r\n  background-image: url(\"../../images/commercial-bg.png\");\r\n  background-size: 100% 100%;\r\n  background-repeat: no-repeat;\r\n  border-radius: 20px;\r\n  padding: 18px 40px 38px 40px;\r\n}\r\n\r\n.dashboard-main-wrap {\r\n  margin-top: 45px;\r\n}\r\n\r\n.dashboard-service-wrapper h3 {\r\n  font-size: 24px;\r\n  color: #1a1919;\r\n  font-weight: 700;\r\n}\r\n\r\n.dashboard-commercial-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 20px;\r\n}\r\n\r\n.dashboard-commercial-image-wrap {\r\n  /* width: 231px; */\r\n  width: 190px;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n  border-radius: 50%;\r\n  padding: 10px;\r\n  /* background: #fff; */\r\n  object-fit: cover;\r\n}\r\n\r\n.dashboard-commercial-image-wrap img {\r\n  width: 100%;\r\n  object-fit: cover;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.dashboard-commercial-wrap:hover .dashboard-commercial-image-wrap {\r\n  /* background-color: #f6f6f6; */\r\n  cursor: pointer;\r\n}\r\n\r\n.dashboard-commercial-wrap:hover .dashboard-commercial-image-wrap img {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.dashboard-commercial-wrap:hover .round-button img {\r\n  transform: scale(1.06);\r\n}\r\n\r\n.dashboard-service-wrap {\r\n  width: 100%;\r\n  display: flex;\r\n  gap: 160px;\r\n  justify-content: center;\r\n  /* margin-top: 10px; */\r\n  margin-top: 40px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.dashbord-right-image-wrapper {\r\n  text-align: right;\r\n}\r\n\r\n.dashbord-right-image-wrapper img {\r\n  width: 86%;\r\n}\r\n\r\n.dashboard-history-main-wrapper {\r\n  margin-top: 20px;\r\n}\r\n\r\n.dashboard-history-main-wrap {\r\n  display: grid;\r\n  grid-template-columns: auto auto;\r\n  gap: 20px;\r\n}\r\n\r\n.dashboard-history-repeat {\r\n  border: 1px solid #f3f3f3;\r\n  background-image: url(\"../../images/booking-card-bg.png\");\r\n  background-size: 100% 100%;\r\n  background-repeat: no-repeat;\r\n  transition: transform 0.3s ease;\r\n  border-radius: 20px;\r\n  padding: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  height: 163px;\r\n  gap: 30px;\r\n  cursor: pointer;\r\n}\r\n\r\n.dashboard-history-repeat:hover {\r\n  border: 1px solid #00a19b;\r\n}\r\n\r\n.dashbord-history-icon-wrap img {\r\n  width: 99px;\r\n}\r\n\r\n.dashboard-history-contant p {\r\n  font-size: 18px;\r\n  color: #1a1919;\r\n  font-weight: 400;\r\n  margin: 0px;\r\n}\r\n\r\n.dashboard-history-repeat.upcoming-active .dashboard-history-contant p {\r\n  color: #1fae04;\r\n}\r\n\r\n.dashboard-history-contant h4 {\r\n  font-size: 34px;\r\n  color: #14172e;\r\n  font-weight: bold;\r\n  padding-top: 5px;\r\n  margin: 0px;\r\n}\r\n\r\n.dashboard-history-repeat.upcoming-active .dashboard-history-contant h4 {\r\n  color: #1fae04;\r\n}\r\n\r\n/******* Resposive css ****/\r\n@media (max-width: 1024px) {\r\n  .dashboard-service-wrapper {\r\n    padding: 8px;\r\n    height: 226px;\r\n    background-image: url(\"../../images/commercial-mobile-bg.png\");\r\n  }\r\n\r\n  .dashboard-history-main-wrapper {\r\n    margin-top: 16px;\r\n  }\r\n\r\n  .dashboard-history-repeat:hover {\r\n    border: 1px solid #00a19b;\r\n  }\r\n\r\n  .dashboard-service-wrapper h3 {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    display: none;\r\n  }\r\n\r\n  .dashboard-commercial-image-wrap {\r\n    /* width: 86px; */\r\n    width: 76px; /*** new added ***/\r\n    padding: 0px;\r\n  }\r\n\r\n  .round-button {\r\n    height: 46px;\r\n  }\r\n\r\n  .dashboard-commercial-wrap {\r\n    flex-direction: row;\r\n    gap: 26px;\r\n  }\r\n\r\n  .dashboard-service-wrap {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n    margin-top: 25px; /*** new added ***/\r\n  }\r\n\r\n  .dashboard-history-main-wrap {\r\n    display: grid;\r\n    grid-template-columns: auto auto;\r\n    gap: 12px;\r\n  }\r\n\r\n  .dashbord-right-image-wrapper {\r\n    display: none;\r\n  }\r\n\r\n  .dashboard-history-repeat {\r\n    background-image: unset;\r\n    gap: 6px;\r\n    /* width: 141px; */\r\n    height: 141px;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    padding: 12px;\r\n  }\r\n\r\n  .dashbord-history-icon-wrap img {\r\n    /* width: 45px; */\r\n    width: 50px;\r\n  }\r\n\r\n  .dashboard-history-contant p {\r\n    font-size: 16px;\r\n    line-height: normal;\r\n  }\r\n\r\n  .dashboard-history-contant h4 {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .dashboard-main-wrap {\r\n    padding-bottom: 100px;\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .dashboard-service-wrapper {\r\n    padding: 20px;\r\n  }\r\n\r\n  .dashboard-history-repeat {\r\n    gap: 6px;\r\n  }\r\n}\r\n\r\n@media (max-width: 330px) {\r\n  .dashboard-service-wrapper {\r\n    padding: 20px;\r\n  }\r\n\r\n  .dashboard-history-contant p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .dashboard-history-repeat {\r\n    gap: 6px;\r\n    padding: 10px;\r\n  }\r\n\r\n  .dashboard-history-contant h4 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dashboard-commercial-image-wrap {\r\n    width: 84px;\r\n  }\r\n\r\n  .dashboard-commercial-wrap {\r\n    gap: 14px;\r\n  }\r\n\r\n  .round-button {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .round-button img {\r\n    width: 14px;\r\n  }\r\n\r\n  .dashbord-history-icon-wrap img {\r\n    width: 56px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .dashboard-service-wrapper {\r\n    padding: 6px;\r\n    height: 270px;\r\n  }\r\n\r\n  .dashboard-service-wrap {\r\n    margin-top: 20px;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .dashboard-service-wrapper h3 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .dashboard-commercial-image-wrap {\r\n    width: 100px;\r\n  }\r\n\r\n  .dashbord-history-icon-wrap img {\r\n    width: 60px;\r\n  }\r\n\r\n  .dashboard-history-contant h4 {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .dashboard-history-contant p {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dashboard-history-repeat {\r\n    height: 150px;\r\n    padding: 12px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .dashbord-right-image-wrapper img {\r\n    width: 100%;\r\n  }\r\n\r\n  .col-md-12.col-lg-7.dashbord-full-width {\r\n    width: 100%;\r\n  }\r\n\r\n  .dashbord-right-image-wrapper {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (min-width: 1025px) and (max-width: 1199px) {\r\n  .dashboard-service-wrapper {\r\n    padding: 20px 26px;\r\n    height: 280px;\r\n  }\r\n\r\n\r\n  .dashboard-main-wrap {\r\n    margin-top: 10px;\r\n    display: flex; \r\n    justify-content: center;\r\n    align-items: center;\r\n    height: calc(100vh - 90px);\r\n  }\r\n\r\n  .dashboard-service-wrap {\r\n    margin-top: 20px;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .dashboard-service-wrapper h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dashboard-commercial-image-wrap {\r\n    width: 140px;\r\n  }\r\n\r\n  .dashbord-history-icon-wrap img {\r\n    width: 56px;\r\n  }\r\n\r\n  .dashboard-history-contant h4 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .dashboard-history-contant p {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .dashboard-history-repeat {\r\n    height: 90px;\r\n    padding: 12px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .dashbord-full-width {\r\n    padding-bottom: 20px;\r\n  }\r\n\r\n  .dashbord-right-image-wrapper img {\r\n    width: 100%;\r\n    /* height: calc(100vh - 130px);\r\n        object-fit: fill; */\r\n  }\r\n\r\n  .dashboard-commercial-wrap {\r\n    gap: 14px;\r\n  }\r\n\r\n  .round-button {\r\n    height: 40px;\r\n    font-size: 12px;\r\n    width: 130px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1599px) {\r\n  .dashboard-main-wrap {\r\n    margin-top: 10px;\r\n    display: flex; \r\n    justify-content: center;\r\n    align-items: center;\r\n    height: calc(100vh - 90px);\r\n  }\r\n\r\n  .dashboard-service-wrapper {\r\n    padding: 23px 27px;\r\n    height: 287px;\r\n  }\r\n\r\n  .dashboard-service-wrapper h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dashboard-commercial-image-wrap {\r\n    /* width: 150px; */\r\n    width: 120px; /*** new added ***/\r\n  }\r\n\r\n  .round-button {\r\n    height: 40px;\r\n    font-size: 12px;\r\n    width: 130px;\r\n  }\r\n\r\n  .dashboard-commercial-wrap {\r\n    gap: 14px;\r\n  }\r\n\r\n  .dashboard-service-wrap {\r\n    /* margin-top: 10px; */\r\n    margin-top: 24px; /*** new added ***/\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .dashbord-history-icon-wrap img {\r\n    width: 66px;\r\n  }\r\n\r\n  .dashboard-history-contant h4 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .dashboard-history-repeat {\r\n    height: 107px;\r\n  }\r\n\r\n  .dashboard-history-contant p {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .dashbord-right-image-wrapper {\r\n    text-align: right;\r\n    width: 394px;\r\n    height: 538px;\r\n  }\r\n\r\n  .dashbord-right-image-wrapper img {\r\n    width: 100%;\r\n  }\r\n\r\n  .dashboard-right-wrap {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n  .dashboard-service-wrapper {\r\n    height: 396px;\r\n  }\r\n\r\n  .dashbord-right-image-wrapper img {\r\n    width: 86%;\r\n    height: 760px;\r\n  }\r\n\r\n  .dashboard-history-repeat {\r\n    padding: 32px 39px;\r\n    gap: 32px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
